import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'cmp-pagination-detail',
  template: `<button *ngIf="!hiddenOnBack" (click)="onBack.emit(null)" class="btn btn-link btn-sm rounded-circle">
  <i class="fa fa-angle-left" aria-hidden="true"></i>
</button>
<button *ngIf="!hiddenOnList" (click)="onList.emit(null)" class="btn btn-link btn-sm font-weight-light">
  Back to List
</button>
<button *ngIf="!hiddenOnNext" (click)="onNext.emit(null)" class="btn btn-link btn-sm rounded-circle">
  <i class="fa fa-angle-right" aria-hidden="true"></i>
</button>
`,
  styles: [``]
})
export class PaginationDetailComponent implements OnInit {

  @Output() onBack = new EventEmitter();
  @Output() onNext = new EventEmitter();
  @Output() onList = new EventEmitter();

  @Input() hiddenOnBack: boolean;
  @Input() hiddenOnNext: boolean;
  @Input() hiddenOnList: boolean;

  constructor() {
  }

  ngOnInit() {
  }

}
